import { proxy } from 'valtio';

class Store {
  splitView: boolean = false;
  previous: boolean = false;

  setSplitView(isSplit: boolean) {
    this.previous = this.splitView;
    this.splitView = isSplit;
  }

  reset() {
    this.previous = false;
    this.splitView = false;
  }
}

const splitViewStore = proxy(new Store());
export default splitViewStore;
